import { WishlistApp } from 'https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.27.1/wishlist-app.js';

const app = new WishlistApp({
  config: wishlist.config,
  settings: wishlist.settings,
  dependencies: wishlist.dependencies,
});

const initComponents = () => {
  app.theme.watch(
    {
      selector: '.wishlist-link .wk-button',
    },
    (target) => {
      app.theme.createHeadlessComponent('wishlist-link-headless', {
        host: target,
      });
    }
  );

  app.theme.watch(
    {
      selector: '.wishlist-button .wk-button',
    },
    (target) => {
      app.theme.createHeadlessComponent('wishlist-button-headless', {
        host: target,
      });
    }
  );
};

app.events.subscribe('wk:app:load-scripts:success', initComponents);
